export class StateLoader {
    url = "http://localhost:state";
    loadState() {
        try {
            let serializedState = localStorage.getItem(this.url);
            if (serializedState === null) {
                return this.initializeState();
            }

            return JSON.parse(serializedState);
        }
        catch (err) {
            return this.initializeState();
        }
    }

    saveState(state) {
        try {
            let serializedState = JSON.stringify(state);
            localStorage.setItem(this.url, serializedState);
        }
        catch (err) {
        }
    }

    initializeState() {
        return {
        }
    }
}
